import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const availableLanguages = {
  "en": "English",
  "hu": "Magyar",
}

const resources = {
  en: {
    translation: {
      "login": "Login",
      "username": "Username",
      "password": "Password",
      "loginButton": "Login",
      "dashboard": "Dashboard",
      "timetable": "Timetable",
      "dataUsage": "Data Usage",
      "outdoorTemperature": "Outdoor temperature",
      "outdoorHumidity": "Outdoor humidity",
      "quickSettings": "Quick settings",
      "logOut": "Log out",
      "back": "Back",
      "newPassword": "New password",
      "newPasswordButton": "Request new password",
      "changeLanguage": "Change language",
      "all": "All",
      "humidity": "Humidity",
      "childLock": "Child Lock",
      "mode": "Mode",
      "setTemperature": "Set Temperature",
      "btnInstall": "Install App",
      "downloadOverlayTitle": "Download the app:",
      "downloadOverlayStep1": 'Press the "Share" icon at the bottom centre.',
      "downloadOverlayStep2": 'Select the "Add to Home Screen" option.',
      "currentMonth": "Current Month",
      "waterHeating": "Water Heating",
      "save": "Save",
      "inactive": "Inactive",
      "loading": "Loading",
      "normal": "Normal",
      "safe": "Safe",
      "tilt": "Tilt",
      "chooseApartmentTitle": "Select another apartment",
      "invalidCredentials": "Wrong e-mail or password",
      "measuredTemperature": "Measured temperature",
      "changePassword": "Change your password",
      "currentPassword": "Old password",
      "confirmPassword": "Confirm new password",
      "passwordsDoNotMatch": "Passwords are different",
      "passwordTooWeak": "The password must contain upper and lower case letters, a number and be at least 8 characters long",
      "passwordRequirement": "Legalább 8 karakter, kis- és nagybetű, valamint szám szükséges",
      "passwordStrong": "A jelszó megfelelő",
      "passwordChangeFailed": "A jelszó módosítása nem sikerült",
      "buildingSelector": {
        "btnTitle": "Select another apartment",
        "building": "Building",
        "selectBuilding": "Select a building",
        "apartment": "Apartment",
        "selectApartment": "Select an apartment",
        "save": "Select",
        "saved": "Building and apartment saved!",
        "error": {
          "selectBoth": "Please select a building and an apartment!"
        }
      }
    },
  },
  hu: {
    translation: {
      "login": "Bejelentkezés",
      "username": "Felhasználónév",
      "password": "Jelszó",
      "loginButton": "Bejelentkezés",
      "dashboard": "Főoldal",
      "timetable": "Időbeosztás",
      "dataUsage": "Fogyasztási adatok",
      "outdoorTemperature": "Külső hőmérséklet",
      "outdoorHumidity": "Külső páratartalom",
      "quickSettings": "Gyors beállítás",
      "logOut": "Kijelentkezés",
      "back": "Vissza",
      "newPassword": "Új jelszó",
      "newPasswordButton": "Új jelszó kérése",
      "changeLanguage": "Nyelv választása",
      "all": "Összes",
      "humidity": "Páratartalom",
      "childLock": "Gyerekzár",
      "mode": "Üzemmód",
      "setTemperature": "Hőmérséklet beállítása",
      "btnInstall": "Alkalmazás telepítése",
      "downloadOverlayTitle": "Az alkalmazás letöltése:",
      "downloadOverlayStep1": 'Nyomd meg a "Megosztás" ikont alul középen.',
      "downloadOverlayStep2": 'Válaszd a "Hozzáadás a Kezdőképernyőhöz" opciót.',
      "currentMonth": "Aktuális hónap",
      "waterHeating": "Melegvíz észítés",
      "save": "Mentés",
      "active": "Aktív",
      "loading": "Betöltés",
      "normal": "Normal",
      "safe": "Biztonságos",
      "tilt": "Dőlt",
      "invalidCredentials": "Hibás e-mail cím vagy jelszó",
      "chooseApartmentTitle": "Másik lakás választás",
      "measuredTemperature": "Mért hőmérséklet",
      "changePassword": "Változtasd meg a jelszavad",
      "currentPassword": "Régi jelszó",
      "confirmPassword": "Új jelszó megerősítése",
      "passwordsDoNotMatch": "A jelszavak nem egyeznek",
      "passwordTooWeak": "A jelszónak tartalmaznia kell kis- és nagybetűt, számot, és legalább 8 karakter hosszúnak kell lennie",
      "passwordRequirement": "Legalább 8 karakter, kis- és nagybetű, valamint szám szükséges",
      "passwordStrong": "A jelszó megfelelő",
      "passwordChangeFailed": "A jelszó módosítása nem sikerült",
      "buildingSelector": {
        "btnTitle": "Másik lakás választása",
        "building": "Épület",
        "selectBuilding": "Válassz épületet",
        "apartment": "Lakás",
        "selectApartment": "Válassz lakást",
        "save": "Választás",
        "saved": "Az épület és a lakás elmentve!",
        "error": {
          "selectBoth": "Válassz ki egy épületet és egy lakást!"
        }
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'hu',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }
});

export default i18n;
